export enum ScheduleSessionModalTestID {
  CloseButton = 'ScheduleSessionModalTestID.CloseButton',
  ScheduleSessionForm = 'ScheduleSessionModalTestID.ScheduleSessionForm',
}
